<template>
    <van-overlay :show="value" z-index="999">
        <div class="wrapper" @click.stop>
            <div class="wrapper-content">
                <div class="wrapper-c-title">
                    <span>{{ title }}</span>
                    <van-icon @click="$emit('close')" name="close"/>
                </div>
                <div class="wrapper-c-content">
                    <slot></slot>
                    <div class="wrapper-c-btn" v-if="confimText">
                        <van-button
                                type="primary"
                                color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
                                block
                                @click="$emit('confirm')"
                        >{{ confimText }}</van-button>
                    </div>
                </div>
            </div>
        </div>
    </van-overlay>
</template>


<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        confimText:{
            type: String,
            default: ""
        }
    }
}
</script>


<style scoped lang="less">
.wrapper {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  min-height: 246px;
  border-radius: 12px;
  overflow: hidden;
  padding: 2px;
  background: linear-gradient(0deg, #523628 0%, #CBB9A9 100%) !important;

  .wrapper-content {
    border-radius: 12px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    min-height: 246px;
    display: flex;
    flex-direction: column;

    .wrapper-c-title {
      background: #302A2A;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      font-size: 18px;
      color: #eddcc9 !important;
    }

    .wrapper-c-content {
      padding: 8px 12px;
      flex: 1;
      color: #eddcc9 !important;
      background: #0a0c07;
    }
  }
}
</style>
